import React from 'react';
import { observer, inject } from 'mobx-react';
import ButtonSpinner from '../ButtonSpinner';
import {Modal,FormGroup,FormControl,ControlLabel,Button} from 'react-bootstrap';

@inject('issueStore')
@observer
export default class AddUser extends React.Component {
    componentDidMount() {

    }
    render() {
        return (
            <Modal show={this.props.issueStore.ShowAddIssue} >
                <Modal.Header>Add/Edit Issue</Modal.Header>
                <Modal.Body>
                    <FormGroup controlId="IssueName" >
                        <ControlLabel>Name</ControlLabel>
                        <FormControl type="text" value={this.props.issueStore.AddIssueRequest.IssueName} name="IssueName" placeholder="Issue Name" onChange={(e) => { this.props.issueStore.UpdateAddIssueProperty(e.target.name, e.target.value) }} />
                    </FormGroup>
                    <FormGroup controlId="Desc" >
                        <ControlLabel>Description</ControlLabel>
                        <FormControl type="text" value={this.props.issueStore.AddIssueRequest.IssueDesc} name="IssueDesc" placeholder="Description" onChange={(e) => { this.props.issueStore.UpdateAddIssueProperty(e.target.name, e.target.value) }} />
                    </FormGroup>
                    <FormGroup controlId="priority" >
                        <ControlLabel>Priority</ControlLabel>
                        <FormControl name="IssuePriority" componentClass="select" value={this.props.issueStore.AddIssueRequest.Priority} onChange={(e)=>{ this.props.issueStore.UpdateAddIssueProperty(e.target.name,e.target.value) }} >
                            <option value="select">Select Priority</option>
                            <option value="Low">Low</option>
                            <option value="Medium">Medium</option>
                            <option value="High">High</option>
                        </FormControl>
                    </FormGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={()=>{ this.props.issueStore.ToggleAddIssueModal(); }}>Close</Button>
                    <Button onClick={()=>{ this.props.issueStore.AddIssue(); }}>Save <ButtonSpinner IsLoading={this.props.issueStore.IsAddingIssue}/> </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Issues/AddIssue.js